import { render, staticRenderFns } from "./ViewPolicy.vue?vue&type=template&id=2f3e15e1&"
import script from "./ViewPolicy.vue?vue&type=script&lang=ts&"
export * from "./ViewPolicy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ViewPolicy.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports